var _style, _polygon, _polygon2, _polygon3, _polygon4, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 100,
    width: 100,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 181.61 201.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n      .shape { fill:#4eba74;stroke:none; }\n  ")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "shape",
    points: "24.59 194.78 30.89 201.18 103.93 127.86 145.72 169.46 151.55 163.81 103.65 115.91 24.59 194.78"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "shape",
    points: "126.71 37.41 120.87 31.76 79.53 73.29 6.09 0 0 6.19 79.08 85.04 126.71 37.41"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "shape",
    points: "144.54 138.26 150.19 132.42 108.59 90.64 181.61 17.4 175.68 11.47 96.92 90.64 144.54 138.26"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "shape",
    points: "33.95 153.41 39.6 159.25 87.93 111.62 8.64 32.28 1.86 39.06 74.89 112.28 33.95 153.41"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "shape",
    x: 99.79,
    y: 144.89,
    width: 8.19,
    height: 20.33
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "shape",
    x: 74.09,
    y: 34.21,
    width: 8.19,
    height: 20.33
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "shape",
    x: 128.02,
    y: 87.58,
    width: 20.33,
    height: 8.19
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "shape",
    x: 36.82,
    y: 107.34,
    width: 20.33,
    height: 8.19
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7bb4f2e3cf7536fe1384af2306720b9b.svg";
export { ForwardRef as ReactComponent };